import React from 'react';
import Alert from './alert';

interface IAlertWithContactProps {
  title?: string;
  type?: 'info' | 'error' | 'warning' | 'success';
  scrollIntoView?: boolean;
}

const AlertWithContact: React.FC<React.PropsWithChildren<IAlertWithContactProps>> = ({ title = 'Fout!', type = 'error', scrollIntoView = false, children }) => (
  <Alert type={type} title={title} scrollIntoView={scrollIntoView}>
    {children}
    <p>Indien u denkt dat dit niet correct is, gelieve contact op te nemen met de OVAM via het IRIS-contactformulier op de OVAM-website.</p>
  </Alert>
);

export default AlertWithContact;
